<button class="yomi-menu__modify" (click)="toggleGlobalGyosekiManagementHeader()">
  <span *ngIf="!isHeaderOpen">
    業績管理表を開く
  </span>
  <span *ngIf="isHeaderOpen">
    業績管理表を閉じる（更新）
  </span>
  <span
    class="yomi-menu__modify__arrow"
    [class.yomi-menu__modify__arrow--down]="!isHeaderOpen"
    [class.yomi-menu__modify__arrow--up]="isHeaderOpen"
  ></span>
</button>

<div
  class="yomic"
  *ngIf="isHeaderOpen"
>
  <div *ngIf="userHasManagementRole" class="yomi-header">
    <ng-container *ngIf="userHasManagementRole">
      <div
        *ngFor="let team of authService.loginUser?.managementTeams"
        class="yomi-header__item btn"
        [ngClass]="{
          'btn--blue': selectedManagementTeamId === team.id,
          'link blue': selectedManagementTeamId !== team.id
        }"
        (click)="updateTableDataWithTeamId(team.id)"
      >
        {{ team.name }}
      </div>
      <div
        *ngIf="userHasManagementRole"
        class="yomi-header__item btn"
        [ngClass]="{
          'btn--blue': !selectedManagementTeamId,
          'link blue': selectedManagementTeamId
        }"
        (click)="updateTableDataWithTeamId(null)"
      >
        個人
      </div>
    </ng-container>
  </div>

  <div class="yomi-subfilter">
    <div class="yomi-subfilter-inner">
      <div class="date-filter">
        <input
          type="month"
          (change)="handleUpdateFilter()"
          [(ngModel)]="selectedExpectedContractMonthValue" />
        <!-- [min]="expectedContractMonthMinOption"
          [max]="expectedContractMonthMaxOption" -->
      </div>

      <div *ngIf="!selectedManagementTeamId" class="goal-filter">
        <span>SN目標</span>
        <input
          type="number"
          [(ngModel)]="salesSummaryForUserModel.rapa.snTarget">
        <button
          class="update-filter btn btn--blue btn--small"
          (click)="handleSaveMyMonthlySalesOverviewForTargetMonth()"
        >
          更新
        </button>
      </div>
      <div *ngIf="selectedManagementTeamId" class="goal-filter">
        <span>SN目標</span>
        <input
          disabled
          type="number"
          [(ngModel)]="salesSummaryForTeamModel.rapa.total.snTarget">
      </div>

      <div *ngIf="!selectedManagementTeamId" class="goal-filter">
        <span>GK目標</span>
        <input
          type="number"
          [(ngModel)]="salesSummaryForUserModel.rapa.gkTarget">
        <button
          class="update-filter btn btn--blue btn--small"
          (click)="handleSaveMyMonthlySalesOverviewForTargetMonth()"
        >
          更新
        </button>
      </div>
      <div *ngIf="selectedManagementTeamId" class="goal-filter">
        <span>GK目標</span>
        <input
          disabled
          type="number"
          [(ngModel)]="salesSummaryForTeamModel.rapa.total.gkTarget">
      </div>

      <div *ngIf="!selectedManagementTeamId" class="goal-filter">
        <span>Mach外売上</span>
        <input
          type="number"
          [(ngModel)]="salesSummaryForUserModel.rapa.externalSalesRevenue">
        <button
          class="update-filter btn btn--blue btn--small"
          (click)="handleSaveMyMonthlySalesOverviewForTargetMonth()"
        >
          更新
        </button>
      </div>
      <div *ngIf="selectedManagementTeamId" class="goal-filter">
        <span>Mach外売上</span>
        <input
          disabled
          type="number"
          [(ngModel)]="salesSummaryForTeamModel.rapa.total.externalSalesRevenue">
      </div>

      <div *ngIf="!selectedManagementTeamId" class="goal-filter">
        <span>GK:</span>
        <ng-content
          *ngTemplateOutlet="
            numDisplaySpan;
            context: {
              value: salesSummaryForUserModel.rapa.gkActual
            }
          "
        >
        </ng-content>
      </div>
      <div *ngIf="selectedManagementTeamId" class="goal-filter">
        <span>GK:</span>
        <ng-content
          *ngTemplateOutlet="
            numDisplaySpan;
            context: { value: salesSummaryForTeamModel?.rapa?.total?.gkActual }
          "
        >
        </ng-content>
      </div>

      <div *ngIf="!selectedManagementTeamId" class="goal-filter">
        <span>GK達成率:</span>
        <ng-content
          *ngTemplateOutlet="
            numDisplaySpan;
            context: {
              value: salesSummaryForUserModel.rapa.gkActualAchievementRate,
              unitLabel: '%'
            }
          "
        >
        </ng-content>
      </div>
      <div *ngIf="selectedManagementTeamId" class="goal-filter">
        <span>GK達成率:</span>
        <ng-content
          *ngTemplateOutlet="
            numDisplaySpan;
            context: {
              value: salesSummaryForTeamModel?.rapa?.total?.gkActualAchievementRate,
              unitLabel: '%'
            }
          "
        >
        </ng-content>
      </div>
      <!-- 週目標 -->
      <!-- <div class="weekly-filter">
        <span>週目標</span>
        <input
          type="text"
          disabled
          [(ngModel)]="expectedContractWeeklyValue">
      </div> -->

    </div>
  </div>
  
  <!-- 業績管理表 - 担当別月間売上 -->
  <ag-gyoseki-management-sales-amount-table
    [selectedManagementTeamId]="selectedManagementTeamId"
    salesType="rapa"
    [salesForUserModel]="salesForUserModel"
    [salesForTeamModel]="salesForTeamModel"
    [salesSummaryForTeamModel]="salesSummaryForTeamModel"
    [salesSummaryForUserModel]="salesSummaryForUserModel"
  ></ag-gyoseki-management-sales-amount-table>


  <!-- 検索条件ダイアログボタン -->
  <ag-customer-filter-button-and-dialog
    [filterDefinitions]="customerFilterDefinitions"
    [currentConditions]="customerFilterConditions"
    (filtersChange)="handleCustomerFilterChange($event)"
  ></ag-customer-filter-button-and-dialog>

  <div class="yomi-pagination">
    <div class="yomi-pagination__range">
      全{{ totalFilteredCount }}件中 {{ pageRangeStart }}件〜{{ pageRangeEnd }}件を表示
    </div>
    <button
      class="yomi-pagination__btn"
      [disabled]="currentPage === 1"
      (click)="goToPage(currentPage - 1)"
    >&lt; 前へ</button>
    <ng-container *ngFor="let p of pageNumbers">
      <span *ngIf="p === '...'" class="yomi-pagination__ellipsis">...</span>
      <button
        *ngIf="p !== '...'"
        class="yomi-pagination__btn"
        [class.yomi-pagination__btn--active]="p === currentPage"
        (click)="goToPage(+p)"
      >{{ p }}</button>
    </ng-container>
    <button
      class="yomi-pagination__btn"
      [disabled]="currentPage === totalPages || totalPages === 0"
      (click)="goToPage(currentPage + 1)"
    >次へ &gt;</button>
  </div>

  <ng-content
    *ngTemplateOutlet="
      table_template;
      context: {
        collection: filteredCustomerProgresses,
        total: filteredCustomerProgresses.length
      }
    "
  >
  </ng-content>
</div>

<ng-template
  #numDisplaySpan
  let-value="value"
  let-unitLabel="unitLabel"
>
  <span *ngIf="!value && value !== 0"> -  {{unitLabel}}</span>
  <span *ngIf="value || value === 0">{{(value | undef | number: '0.0-2')}} {{unitLabel}}</span>
</ng-template>

<ng-template #headerTemplate>
  <thead>
    <tr>
      <th *ngIf="selectedManagementTeamId" class="yomic_table__th yomic_table__th__username">
        ユーザー名
        <span
          *ngIf="userNameSortStatus === 'asc'"
          (click)="handlerUserNameSort()"
        >
          <img class="yomic_table__th__active__img" src="/assets/icons/arrow-up.png" />
        </span>
        <span
          *ngIf="userNameSortStatus === 'desc'"
          (click)="handlerUserNameSort()"
        >
          <img class="yomic_table__th__active__img" src="/assets/icons/arrow-down.png" />
        </span>
      </th>
      <th class="yomic_table__th yomic_table__th__komi">
        ヨミ
        <span
          *ngIf="yomiSortStatus === 'asc'"
          (click)="handlerYomiSort()"
        >
          <img class="yomic_table__th__active__img" src="/assets/icons/arrow-up.png" />
        </span>
        <span
          *ngIf="yomiSortStatus === 'desc'"
          (click)="handlerYomiSort()"
        >
          <img class="yomic_table__th__active__img" src="/assets/icons/arrow-down.png" />
        </span>
      </th>
      <th class="yomic_table__th yomic_table__th__active">
        稼働
        <span
          *ngIf="activeSortStatus === 'asc'"
          (click)="handlerActiveSort()"
        >
          <img class="yomic_table__th__active__img" src="/assets/icons/arrow-up.png" />
        </span>
        <span
          *ngIf="activeSortStatus === 'desc'"
          (click)="handlerActiveSort()"
        >
          <img class="yomic_table__th__active__img" src="/assets/icons/arrow-down.png" />
        </span>
      </th>
      <th class="yomic_table__th yomic_table__th__progress">
        進捗
        <span
          *ngIf="progressSortStatus === 'asc'"
          (click)="handlerProgressSort()"
        >
          <img class="yomic_table__th__progress__img" src="/assets/icons/arrow-up.png" />
        </span>
        <span
          *ngIf="progressSortStatus === 'desc'"
          (click)="handlerProgressSort()"
        >
          <img class="yomic_table__th__progress__img" src="/assets/icons/arrow-down.png" />
        </span>
      </th>
      <th class="yomic_table__th yomic_table__th__customer">
        求職者
        <span
          *ngIf="graduateYearSortStatus === 'asc'"
          (click)="handlerGraduateYearSort()"
        >
          <img class="yomic_table__th__customer__img" src="/assets/icons/arrow-up.png" />
        </span>
        <span
          *ngIf="graduateYearSortStatus === 'desc'"
          (click)="handlerGraduateYearSort()"
        >
          <img class="yomic_table__th__customer__img" src="/assets/icons/arrow-down.png" />
        </span>
      </th>
      <th class="yomic_table__th yomic_table__th__actions">&#8195;&#8195;</th>
      <th class="yomic_table__th yomic_table__th__sf">
        SF
        <span
          *ngIf="sfSortStatus === 'asc'"
          (click)="handlerSfSort()"
        >
          <img class="yomic_table__th__sf__img" src="/assets/icons/arrow-up.png" />
        </span>
        <span
          *ngIf="sfSortStatus === 'desc'"
          (click)="handlerSfSort()"
        >
          <img class="yomic_table__th__sf__img" src="/assets/icons/arrow-down.png" />
        </span>
      </th>
      <th class="yomic_table__th yomic_table__th__enterprise">ご支援想定企業</th>
      <th class="yomic_table__th yomic_table__th__memo-now">SK</th>
      <th class="yomic_table__th yomic_table__th__yomi3">
        <div class="th-yomi3-upper-area">3軸のヨミ情報</div>
        <div class="th-yomi3-lower-area">
          <span
            *ngIf="yomi3PassedSortStatus === 'asc'"
            (click)="handlerYomi3Sort(Yomi3Target.passed)"
          >
            合格<img class="yomic_table__th__sf__img" src="/assets/icons/arrow-up.png" />
          </span>
          <span
            *ngIf="yomi3PassedSortStatus === 'desc'"
            (click)="handlerYomi3Sort(Yomi3Target.passed)"
          >
            合格<img class="yomic_table__th__sf__img" src="/assets/icons/arrow-down.png" />
          </span>
          <span
            *ngIf="yomi3InclinationSortStatus === 'asc'"
            (click)="handlerYomi3Sort(Yomi3Target.inclination)"
          >
            意向<img class="yomic_table__th__sf__img" src="/assets/icons/arrow-up.png" />
          </span>
          <span
            *ngIf="yomi3InclinationSortStatus === 'desc'"
            (click)="handlerYomi3Sort(Yomi3Target.inclination)"
          >
            意向<img class="yomic_table__th__sf__img" src="/assets/icons/arrow-down.png" />
          </span>
          <span
            *ngIf="yomi3ScheduleSortStatus === 'asc'"
            (click)="handlerYomi3Sort(Yomi3Target.schedule)"
          >
            日程<img class="yomic_table__th__sf__img" src="/assets/icons/arrow-up.png" />
          </span>
          <span
            *ngIf="yomi3ScheduleSortStatus === 'desc'"
            (click)="handlerYomi3Sort(Yomi3Target.schedule)"
          >
            日程<img class="yomic_table__th__sf__img" src="/assets/icons/arrow-down.png" />
          </span>
        </div>
      </th>
      <th class="yomic_table__th yomic_table__th__memo-now">メモ</th>
      <th class="yomic_table__th yomic_table__th__ca-yomi">CAヨミ</th>
      <th class="yomic_table__th yomic_table__th__enterprise">CAご支援想定企業</th>
      <th class="yomic_table__th yomic_table__th__enterprise">CA第2ご支援想定企業</th>
    </tr>
  </thead>
</ng-template>

<ng-template
  #table_template
  let-collection="collection"
  let-total="total"
>
  <table class="yomic_table" *ngIf="total">
    <ng-content *ngTemplateOutlet="headerTemplate"></ng-content>
    <div class="loading" *ngIf="loadingCustomer">
      <svg class="loading__spinner" viewBox="0 0 50 50">
        <circle class="loading__spinner__path" cx="25" cy="25" r="20"></circle>
      </svg>
    </div>
    <tbody>
      <tr
        *ngFor="let progress of collection"
      >
      <ng-container *ngIf="getCustomerFromProgress(progress) as customer" >
        <td *ngIf="selectedManagementTeamId && getRaUserFromProgress(progress) | async as user" class="yomic_table__td">
          <div class="td-wrap">
            <span class="yomic_table__td_active__data">
              {{user.name}}
            </span>
          </div>
        </td>
        <td class="yomic_table__td">
          <div class="td-wrap">
            <!-- This should be dynamic (?) and update based on records... -->
            <!-- Also research into what is a normal select dropdown in this project E.g. <ag-select> -->
            <select
              class="select select--bg-gray select--small"
              [(ngModel)]="progress.dynamicData.raYomi"
              (change)="handlerRaYomiTypeChange(progress.id, progress.dynamicData.raYomi)"
            >
              <option
                  *ngFor="let dd of yomiDropdownData"
                  [ngValue]="dd.value"
                  >{{ dd.label }}</option
                >
            </select>
          </div>
        </td>
        <td class="yomic_table__td">
          <div class="yomic_table__td_active">
            <span class="yomic_table__td_active__data">
              {{ customer.activeCount }}
            </span>
          </div>
        </td>
        <td class="yomic_table__td">
          <div class="yomic_table__td_progress">
            <span class="yomic_table__td_progress__data">
              {{ customer.progressCount }}
            </span>
          </div>
        </td>
        <td class="yomic_table__td">
          <div class="yomic_table__td_customer">
            <div class="yomic_table__td_customer__above">
              <span class="yomic_table__td_customer__above__frontid">
                {{customer?.frontId}}
              </span>
              <span
                *ngIf="customer?.dynamicData?.academicFieldType"
                class="yomic_table__td_customer__above__flag"
                [class.yomic_table__td_customer__above__flag--pink]="
                  customer?.dynamicData?.academicFieldType?.includes('文')
                "
                [class.yomic_table__td_customer__above__flag--blue]="
                  customer?.dynamicData?.academicFieldType?.includes('理')
                "
                >{{
                  customer?.dynamicData.academicFieldType.includes("文") ? "文" : "理"
                }}</span
              >
              <span
                *ngIf="customer?.dynamicData?.academicHistory1?.graduateYear"
                class="yomic_table__td_customer__above__flagg yomic_table__td_customer__above__flagg--blue"
              >
                {{handlerGraduateYearView(customer.dynamicData.academicHistory1.graduateYear) }} 卒
              </span>
              <span class="yomic_table__td_customer__above__rank">
                |&nbsp;{{customer?.dynamicData.universityLevel | slice: 0 : 1}}&nbsp;|
              </span>
            </div>
            <div
              class="yomic_table__td_customer__under"
              (click)="onItemSelect(customer)"
            >
              {{customer?.fullName}}
            </div>
          </div>
        </td>
        <td class="yomic_table__td">
          <div class="yomic_table__td_actions">
            <div class="yomic_table__td_actions__above">
              <a
                class="yomic_table__td_actions__chat"
                (click)="onItemSelect(customer)"
              >
                <div class="yomic_table__td_actions__icon">
                  <img class="yomic_table__td_actions__img" src="/assets/images/phone.png" />
                </div>
              </a>
              <a
                class="yomic_table__td_actions__chat"
                (click)="
                  true
                    ? openChat(customer?.dynamicData?.lineId)
                    : ''
                "
              >
                <div class="yomic_table__td_actions__icon">
                  <img class="yomic_table__td_actions__img" src="/assets/images/chat.png" />
                </div>
              </a>
            </div>
            <div class="yomic_table__td_actions__under">
              <a
                class="yomic_table__td_actions__chat"
                (click)="
                  customer.dynamicData?.emailMain?.email &&
                  !customer.dynamicData?.emailMain?.emailAvailable
                    ? openMailSend(sendConfig, customer)
                    : ''
                "
              >
                <div class="yomic_table__td_actions__icon">
                  <img class="yomic_table__td_actions__img" src="/assets/images/mail.png" />
                </div>
              </a>
              <a
                class="yomic_table__td_actions__chat"
                (click)="onItemSelectAndMemo(customer)"
              >
                <div class="yomic_table__td_actions__icon">
                  <img class="yomic_table__td_actions__img" src="/assets/images/note.png" />
                </div>
              </a>
            </div>
          </div>
        </td>
        <td class="yomic_table__td">
          <div class="yomic_table__td_sf">
            <span
              *ngIf="customer?.dynamicData?.rank"
              class="yomic_table__td_sf--flag yomic_table__td_sf--flag--{{ customer.dynamicData.rank }}"
            >{{customer.dynamicData.rank}}</span>
          </div>
        </td>
        <td class="yomic_table__td">
          <div class="yomic_table__td_enterprise">
            <div class="yomic_table__td_enterprise__above">
              <span
                class="link"
                (click)="handleOpenEnterpriseDetail(progress)"
              >
                {{ getEnterpriseNameFromProgress(progress) }}
              </span>
            </div>
            <div class="yomic_table__td_enterprise__under">
              <span
                class="yomic_table__td_enterprise__under__flagg"
                [class.yomic_table__td_enterprise__under__flagg--ag]="progress.type == 0"
                [class.yomic_table__td_enterprise__under__flagg--plus]="progress.type == 1"
              >{{handlerExpectedCompanyTypeView(progress.type)}}</span>

              <span *ngIf="customersExpectedCompanyMapping[customer.id]" class="yomic_table__td_enterprise__under__user">
                {{ customersExpectedCompanyMapping[customer.id].ca_u_name | truncate: 5 }}
              </span>
              <span *ngIf="customersExpectedCompanyMapping[customer.id]" class="yomic_table__td_enterprise__under__status">
                {{ getProgressStatusViewFromProgress(progress) | truncate: 6 }}
              </span>
              <span *ngIf="customersExpectedCompanyMapping[customer.id] && customersExpectedCompanyMapping[customer.id].p_seminar_at" class="yomic_table__td_enterprise__under__date">
                {{ progress.seminarAt | date: "yyyy/MM/dd" }}
              </span>
            </div>
          </div>
        </td>
        <!-- SK -->
        <td class="yomic_table__td">
          <div class="yomic_table__td__sk">
            <div class="yomic_table__td__sk-input-area">
              <input
                type="number"
                [(ngModel)]= "progress.dynamicData.sk"
              />
              <button
                class="update-filter btn btn--blue btn--minimum"
                (click)="handleShowRaExpectedSKInfoDialog(progress)"
              ></button>
            </div>
            <button
              class="update-filter btn btn--blue btn--small"
              (click)="handleRaExpectedSKUpdate(progress, progress.dynamicData.sk)"
            >更新</button>
          </div>
        </td>
        <!-- ヨミ3軸 -->
        <td class="yomic_table__td">
          <div class="td-wrap">
            <div class="yomic_table__td__ca3yomis">
              <div class="yomic_table__td__ca3yomi-upper-area">
                <select
                  class="select select--bg-gray select--small"
                  [(ngModel)]="progress.dynamicData.raYomi3Passed"
                  (ngModelChange)="handleRaYomi3Change(progress, Yomi3Target.passed)"
                >
                  <option
                      *ngFor="let dd of yomi3PassedDropdownData"
                      [ngValue]="dd.value"
                      >{{ dd.label }}</option
                    >
                </select>
                <select
                  class="select select--bg-gray select--small"
                  [(ngModel)]="progress.dynamicData.raYomi3Inclination"
                  (ngModelChange)="handleRaYomi3Change(progress, Yomi3Target.inclination)"
                >
                  <option
                      *ngFor="let dd of yomi3InclinationDropdownData"
                      [ngValue]="dd.value"
                      >{{ dd.label }}</option
                    >
                </select>
                <select
                  class="select select--bg-gray select--small"
                  [(ngModel)]="progress.dynamicData.raYomi3Schedule"
                  (ngModelChange)="handleRaYomi3Change(progress, Yomi3Target.schedule)"
                >
                  <option
                      *ngFor="let dd of yomi3ScheduleDropdownData"
                      [ngValue]="dd.value"
                      >{{ dd.label }}</option
                    >
                </select>
              </div>
              <div class="yomic_table__td__ca3yomi-lower-area">
                <ng-container
                  *appLet="
                    getRaYomi3ProbabilityResultFromProgress(progress) as raYomi3ProbabilityResult
                  "
                >
                <div class="yomi3-probability-calc-result">
                  <div
                    class="yomi3-probability-calc-result--label"
                    [ngClass]="{
                      'max': raYomi3ProbabilityResult.label === 'MAX',
                      'mid': raYomi3ProbabilityResult.label === 'MID',
                      'min': raYomi3ProbabilityResult.label === 'MIN'
                    }"
                    *ngIf="raYomi3ProbabilityResult.label"
                  >
                    {{raYomi3ProbabilityResult.label}}
                  </div>
                  <div
                    class="yomi3-probability-calc-result--probability"
                  >
                    {{(raYomi3ProbabilityResult.probability | number:'1.1-2') || '------'}}
                  </div>
                </div>
                <input
                  type="month"
                  (change)="handleUpdateRaExpectedContractMonth($event, progress)"
                  [value]="getYearMonthFromDateString(progress.dynamicData.raExpectedContractMonth)" />
                <select
                  class="select select--bg-gray select--small"
                  [(ngModel)]="progress.dynamicData.raExpectedContractWeek"
                  (change)="handleUpdateRaExpectedContractWeek(progress)"
                  >
                  <option
                      *ngFor="let dd of expectedContractWeekDropdownData"
                      [ngValue]="dd.value"
                      >{{ dd.label }}</option
                    >
                </select>
              </ng-container>
              </div>
            </div>
          </div>
        </td>
        <!-- メモ -->
        <td class="yomic_table__td">
          <div class="td-wrap">
            <div class="yomic_table__td_memos">
              <textarea
                class="yomic_table__td_memos__text"
                [(ngModel)]= "progress.dynamicData.raMemo"
              ></textarea>

              <button
                class="update-filter btn btn--blue btn--small"
                (click)="handleSaveRaMemo(progress.id, progress.dynamicData.raMemo)"
              >更新</button>
            </div>
          </div>
        </td>
        <td class="yomic_table__td">
          <div class="td-wrap">
            <ng-container *ngIf="customersExpectedCompanyMapping[customer.id] as caYomi">
              <div class="yomic_table__td__ca-yomi-display">
                <div class="yomic_table__td__ca-yomi-display-main">
                  <span>{{ customer?.dynamicData?.yomi || '-' }}</span>
                  <span>{{ caYomi?.e_name || '-' }}</span>
                  <span>{{ (customer?.dynamicData?.expectedContractMonth | date: 'yyyy年M月') || '-' }}</span>
                </div>
                <div class="yomic_table__td__ca-yomi-display-sub">
                  <div class="yomic_table__td__ca-yomi-display-sub">
                    <span>{{ caYomi?.p_yomi_3_passed || '-' }}</span>
                    <span>×</span>
                    <span>{{ caYomi?.p_yomi_3_inclination || '-' }}</span>
                    <span>×</span>
                    <span>{{ caYomi?.p_yomi_3_schedule || '-' }}</span>
                  </div>
                  <div class="yomic_table__td__ca-yomi-display-probability">
                    <div
                      class="yomi3-probability-calc-result--label"
                      [ngClass]="{
                        'max': caYomi?.yomi3ProbabilityCalcResult?.label === 'MAX',
                        'mid': caYomi?.yomi3ProbabilityCalcResult?.label === 'MID',
                        'min': caYomi?.yomi3ProbabilityCalcResult?.label === 'MIN'
                      }"
                    >
                      {{ caYomi?.yomi3ProbabilityCalcResult?.label || '-' }}
                    </div>
                    <div class="yomi3-probability-calc-result--probability">
                      {{ (caYomi?.yomi3ProbabilityCalcResult?.probability | number:'1.1-2') || '-' }}
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </td>
        <td class="yomic_table__td">
          <div class="yomic_table__td_enterprise">
            <div class="yomic_table__td_enterprise__above">
              <span
                *ngIf="customersExpectedCompanyMapping[customer.id]"
                class="link"
                (click)="handleOpenEnterpriseDetailWithId(
                  customersExpectedCompanyMapping[customer.id].e_id
                )"
              >
                {{ customersExpectedCompanyMapping[customer.id].e_name }}
              </span>
            </div>
            <div class="yomic_table__td_enterprise__under">
              <span
                *ngIf="customersExpectedCompanyMapping[customer.id]"
                class="yomic_table__td_enterprise__under__flagg"
                [class.yomic_table__td_enterprise__under__flagg--ag]="customersExpectedCompanyMapping[customer.id].p_type === 0"
                [class.yomic_table__td_enterprise__under__flagg--plus]="customersExpectedCompanyMapping[customer.id].p_type === 1"
              >{{handlerExpectedCompanyTypeView(customersExpectedCompanyMapping[customer.id].p_type)}}</span>

              <span *ngIf="customersExpectedCompanyMapping[customer.id]" class="yomic_table__td_enterprise__under__user">
                {{ customersExpectedCompanyMapping[customer.id].ca_u_name | truncate: 5 }}
              </span>
              <span *ngIf="customersExpectedCompanyMapping[customer.id]" class="yomic_table__td_enterprise__under__status">
                {{ handlerProgressStatusView(customersExpectedCompanyMapping[customer.id]) | truncate: 6 }}
              </span>
              <span *ngIf="customersExpectedCompanyMapping[customer.id] && customersExpectedCompanyMapping[customer.id].p_seminar_at" class="yomic_table__td_enterprise__under__date">
                {{ customersExpectedCompanyMapping[customer.id].p_seminar_at | date: "yyyy/MM/dd" }}
              </span>
            </div>
          </div>
        </td>
        <!-- ご支援想定企業 2 -->
        <td class="yomic_table__td">
          <div class="yomic_table__td_enterprise">
            <div class="yomic_table__td_enterprise__above">
              <span
                *ngIf="customersExpectedCompany2Mapping[customer.id]"
                class="link"
                (click)="handleOpenEnterpriseDetailWithId(
                  customersExpectedCompanyMapping[customer.id].e_id
                )"
              >
                {{ customersExpectedCompany2Mapping[customer.id].e_name }}
              </span>
            </div>
            <div class="yomic_table__td_enterprise__under">
              <span
                *ngIf="customersExpectedCompany2Mapping[customer.id]"
                class="yomic_table__td_enterprise__under__flagg"
                [class.yomic_table__td_enterprise__under__flagg--ag]="customersExpectedCompany2Mapping[customer.id].p_type === 0"
                [class.yomic_table__td_enterprise__under__flagg--plus]="customersExpectedCompany2Mapping[customer.id].p_type === 1"
              >{{handlerExpectedCompanyTypeView(customersExpectedCompany2Mapping[customer.id].p_type)}}</span>

              <span *ngIf="customersExpectedCompany2Mapping[customer.id]" class="yomic_table__td_enterprise__under__user">
                {{ customersExpectedCompany2Mapping[customer.id].ca_u_name | truncate: 5 }}
              </span>
              <span *ngIf="customersExpectedCompany2Mapping[customer.id]" class="yomic_table__td_enterprise__under__status">
                {{ handlerProgressStatusView(customersExpectedCompany2Mapping[customer.id]) | truncate: 6 }}
              </span>
              <span *ngIf="customersExpectedCompany2Mapping[customer.id] && customersExpectedCompany2Mapping[customer.id].p_seminar_at" class="yomic_table__td_enterprise__under__date">
                {{ customersExpectedCompany2Mapping[customer.id].p_seminar_at | date: "yyyy/MM/dd" }}
              </span>
            </div>
          </div>
        </td>
      </ng-container>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td class="yomic_table__td" colspan="100%">
          合計: {{total}}件
        </td>
      </tr>
    </tfoot>
  </table>
</ng-template>
